import { Text, View } from '@react-pdf/renderer'

import { IncidentActionType } from '@/graphql/generated/schemas'

import { styles } from '../styles/styles'
import { DownloadReportButtonIProps } from '../types/types'
import { calculateResolutionTimeInDays } from '../utils/utils'
import { SectionTitle } from './SectionTitle'

export const Resolution = ({ incident }: DownloadReportButtonIProps) => {
  const resolutionAction = incident?.actions?.find(
    (i) => i.type === IncidentActionType.Resolved
  )

  const resolutionTimeInDays = calculateResolutionTimeInDays(
    resolutionAction?.createdAt,
    incident?.createdAt
  )
  return (
    <View style={styles.section}>
      <SectionTitle icon='resolution' title='Resolution' />
      <View style={styles.resolutionRow}>
        <Text style={styles.detailLabel}>Resolution description:</Text>
        <Text style={styles.detailValue}>{resolutionAction?.message}</Text>
      </View>
      <View style={styles.resolutionRow}>
        <Text style={styles.detailLabel}>Was this a real incident?</Text>
        <Text style={styles.detailValue}>
          {incident?.real ? 'Yes, real' : 'No, false'}
        </Text>
      </View>
      {resolutionAction && (
        <View style={styles.resolutionRow}>
          <Text style={styles.detailLabel}>Time to resolve:</Text>
          <Text style={styles.detailValue}>{resolutionTimeInDays}</Text>
        </View>
      )}
      <View style={styles.sectionDivider} />
    </View>
  )
}
